<template>
	<div class="scrollable only-y">
	<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-monitor-multiple widget-icon accent-text fs-30"></i> {{ $t('menu.business') }}</h2>
		</div>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
			<el-tab-pane label="Dashboard" name="dashboardbusiness">
				<dashboard-business :data-dashboard="dataDashboard" :data-meta="dataDashboardMeta" :loading-data="loadingTemplate" :date="selectedStartDateDashboard" />
			</el-tab-pane>
			<el-tab-pane label="Active Business" name="activebusiness">
				<active-business :data-active="dataActive" :total="dataActiveTotal" :loading-data="loadingTemplate" :date="selectedStartDateActive" :type="selectedMessageTypeField" :filter="selectedFilter" :field="selectedField" />
			</el-tab-pane>
			<el-tab-pane label="Top 20" name="toptwenty">
				<top-twenty :data-twenty="dataTwenty" :loading-data="loadingTemplate" :detail-data="detailDataTwenty" :data-summary="dataTwentySummary" :date="selectedStartDateTwenty" />
			</el-tab-pane>	  
			<!-- <el-tab-pane label="Facebook Identity" name="fbidentity">
				<facebook-identity :data-identity="reqFbIdentity" :loading-data="loadingTemplate" :total="totalFbIdentity" />
			</el-tab-pane>
			<el-tab-pane label="Facebook Sessions" name="fbsession">
				<facebook-session :data-session="reqFbSession" :data-summary="reqFbSessionSummary" :data-warning="reqFbSessionWarn" :loading-data="loadingTemplate" :total="totalFbSession" :date="selectedStartDateSession" />
			</el-tab-pane>
			<el-tab-pane label="Facebook Price" name="fbprice">
				<facebook-price :data-price="reqFbPrice" :loading-data="loadingTemplate" :total="totalFbPrice" />
			</el-tab-pane>
			<el-tab-pane label="PIC Business" name="picbusiness">
				<pic-business :data-pic="picBusinessGroup" :loading-data="loadingTemplate" />
			</el-tab-pane> -->
		</el-tabs>
	</el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import FacebookIdentity from './business/FacebookIdentity.vue'
import PicBusiness from './business/PicBusiness.vue'
import FacebookPrice from './business/FacebookPrice.vue'
import FacebookSession from './business/FacebookSession.vue'
import TopTwenty from './business/TopTwenty.vue'
import ActiveBusiness from './business/ActiveBusiness.vue'
import DashboardBusiness from './business/DashboardBusiness.vue'

import api from '@/networkClient'
import config from '@/config'
import CountryFlag from 'vue-country-flag'
const _ = require('lodash')
const moment = require('moment')
const countryCodes = require('country-codes-list')

export default {
   name: 'Business',
	components: {
		FacebookIdentity,
		PicBusiness,
		FacebookPrice,
		FacebookSession,
		TopTwenty,
		ActiveBusiness,
		DashboardBusiness,
		CountryFlag
	},
	data () {
		return {
			dataDashboardMeta: {
                "conversation_total": 0,
                "conversation_bi": 0,
                "conversation_ui": 0,
                "revenue_total": 0,
                "revenue_bi": 0,
                "revenue_ui": 0,
                "phone_number_passive": 0,
                "phone_number_active": 0,
                "waba_active": 0,
                "waba_passive": 0,
                "send": 0,
                "delivered": 0
            },
			selectedField: 'waba_id',
			selectedFilter : moment().format("YYYY-MM"),
			selectedMessageTypeField: "monthly",
			dataActive:[],
			dataActiveTotal:0,
			dataTwentySummary: [],
			monthly: [],
			detailDataTwenty: {},
			totalDataTwenty: 0,
			dataTwenty: [],
			dataDashboard: [],
			loadingDetailSession: false,
			dataDetailSession:[],
			modalDetaiSession: false,
			phoneNumberSessionSelected: "",
			idDetailSession: "",
			paginate: true,
			processList:[],
			bodyStyle: {
				padding: "20px"
			},
			loadingSession: false,
			searchFbSession:"",
			filterByIdentity: [{value:"waba_id", label:"WABA ID"},{value:"masking_name", label:"Masking Name"}],
			filterBySession:[{value:"waba_id", label:"WABA ID"},{value:"phone_number", label:"Phone Number"}],
			selectedFilterSession:"waba_id",
			selectedFilterIdentity: "waba_id",
			selectedMessageTypeFieldTwenty:"waba",
			selectedFilterTwenty:"meta_conversation",
			selectedStartDateActive: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
			selectedStartDateSession: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
			selectedStartDateTwenty: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
			selectedStartDateDashboard: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            price_bi: 0,
            price_ui: 0,
            country_code: '',
            country_name: "",
            domain_name: '',
			types: [{label: "WABA ID", value: "waba_id"},{label: "FBBM ID", value: "fbbm_id"}],
			phoneNumberSession: [],
            countries: [],
			mapingCountries: [],
			reqFbPriceIdentity:[],
			price_model_identity:[{model:{modelName: "",countryName: "", domainName:""}}],
            model_name:"",
			type_identity:"waba_id",
			identityNumber: "",
			maskingName: "",
            price_model: "1",
			price_model_edit: "1",
			editTemplate: {
				dialog: false,
				object: {},
				loadingBtn: false
			},
			editFbPrice: {},
			editIdentity: {},
			hsm:[],
			reqFbPrice: [],
			reqFbIdentity: [],
			reqFbSession: [],
			reqFbSessionSummary: {
				waba_active: 0,
				waba_passive : 0,
				phone_number_active: 0,
				phone_number_passive: 0,
				conversation_bi: 0,
				conversation_ui: 0,
				revenue_total: 0
			},
			reqFbSessionWarn: null,
			loadingTemplate: true,
			loadingIdentity: false,
			currentPage: 1,
			currentPageRequest: 1,
			currentPageIdentity: 1,
			currentPageSession: 1,
			total:'',
			totalFbPrice: 0,
			totalFbIdentity: 0,
			totalFbSession: 0,
			dialogFormVisible:false,
			dialogFormVisibleIdentity:false,
			dialogFormVisibleEdit:false,
			dialogFormVisibleEditIdentity:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			searchFbPrice:'',
			searchFbIdentity:'',
			activeTab: "dashboardbusiness",
			activeTabSession: "index",
			loadingApproved: false,
			picBusinessGroup: []
		}
	},
	methods: {
		doSearchFbPrice(){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.getFbPrice()
			}, 1000)
		},
		changeFilterSession(){
			// console.log("filter session");
			this.getFbSession(1,this.selectedFilterSession)
			this.getFbSessionSummary(this.selectedFilterSession)
		},
		changeFilterIdentity(){
			this.paginate = this.searchFbIdentity.trim() == '' ? true:false
			this.getFbIdentity(1,this.selectedFilterIdentity)
		},
		find_duplicate_in_array(arra1, param) {
			var object = {};
			var result = [];

			arra1.forEach(function (item) {
			if(!object[item[param].countryName])
				object[item[param].countryName] = 0;
				object[item[param].countryName] += 1;
			})

			for (var prop in object) {
			if(object[prop] >= 2) {
				result.push(prop);
			}
			}

			return result;

		},
		addDataIdentity(){
			this.mapingCountries = this.countries
			this.dialogFormVisibleIdentity = true
		},
		addModel(){
			this.price_model_identity.push({model:{modelName: "",countryName: "", domainName:""}})
		},
		addModelEdit(){
			this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
		},
		deleteModel(i){
			this.price_model_identity.splice(i,1)
		},
		deleteModelEdit(i){
			this.editIdentity.price_model.splice(i,1)
		},
		formatType(val){
			let result = ""
			result = val.replace("_", " ").toUpperCase();
			return result ;
		},
		formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, field, field2 = undefined) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			if (field2) {
				this[field][field2] = FilteredChars
			}
			else{
				this[field] = FilteredChars
			}
        },
		async detailFbIdentity(val){
			// console.log(val);
			this.editIdentity = val
			this.editIdentity.adminName = val.admin.username || ''
			if (this.editIdentity.type == 'waba_id') {
				this.detailPrice(val.id)
				// if (this.editIdentity.price_model.length > 0) {
				// 	this.editIdentity.price_model.forEach( async (el,i) => {
				// 		this.searchFbPrice = el.facebook_price.countryName
				// 		await this.getFbPrice()
				// 		this.reqFbPriceIdentity[i] = this.reqFbPrice
				// 	})
				// }
				// else{
				// 	this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
				// }
			}
			else{
				this.dialogFormVisibleEditIdentity = true
			}
			// setTimeout(() => {
			// 	this.dialogFormVisibleEditIdentity = true
			// }, 100);
		},
		async detailFbSession(val){
			// console.log(val);
			// console.log(this.phoneNumberSession);
			this.idDetailSession = val.id
			this.phoneNumberSession = val.sessions.map(el => {
					let obj = {
						label: el.phoneNumber,
						value: el.phoneNumber
					}
					return obj
				})
			this.phoneNumberSessionSelected = this.phoneNumberSession[0].value || null
			this.modalDetaiSession = true
			await this.getFbSessionDetail()
		},
		async handleChangeSelectedSession(val){
			this.phoneNumberSessionSelected = val
			await this.getFbSessionDetail()
		},
		async handleChangeSelectedModel(val, key){
			// console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.price_model_identity[key].model.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedModelEdit(val, key){
			// console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.editIdentity.price_model[key].facebook_price.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedCountryModel(val, key){
            // console.log('val', val, key);
			this.searchFbPrice = val
			this.price_model_identity[key].model.modelName = ""
			this.price_model_identity[key].model.domainName = ""
			this.price_model_identity[key].model.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		async handleChangeSelectedCountryModelEdit(val, key){
            // console.log('val', val, key);
			this.searchFbPrice = val
			this.editIdentity.price_model[key].facebook_price.modelName = ""
			this.editIdentity.price_model[key].facebook_price.domainName = ""
			this.editIdentity.price_model[key].facebook_price.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		handleChangeSelectedIdentity(val){
			// console.log(val);
			if (val == "waba_id" && this.editIdentity.price_model.length == 0) {
				this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
			}
		},
        handleChangeSelectedCountry(val){
            // console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.country_code = "+" + find.countryCallingCode
                this.domain_name = find.countryCode    
            }
            
        },
		handleChangeSelectedCountryEdit(val){
            // console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.editFbPrice.country_code = "+" + find.countryCallingCode
                this.editFbPrice.domain_name = find.countryCode    
            }
            
        },
		detailFbPrice(row){
			// console.log('row selectd',row)
			this.editFbPrice = row
			this.editFbPrice.model_name = row.modelName
			this.price_model_edit = '2'

			if (!this.editFbPrice.model_name) {
				this.price_model_edit = '1'
			}
			this.editFbPrice.domain_name = row.domainName
			this.editFbPrice.country_code = "+"+row.countryCode
			this.editFbPrice.country_name = row.countryName
			this.editFbPrice.dateCreate = row.dateCreate
			this.dialogFormVisibleEdit = true
		},
		deleteFbIdentity(row){
			// console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this identity?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-identity/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), res.data.message, "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginateFbIdentity()
						this.paginateFbPrice(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		deleteFbPrice(row){
			// console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this price?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-price/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginateFbPrice()
						this.paginateFbPrice(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		clickUpdateTemplate(object){
			this.editTemplate.object = _.clone(object)
			this.editTemplate.dialog = true
		},
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		tabClick(tab){
			if(tab.name == "activebusiness"){
				// this.getActive()
			}
			else if(tab.name == "toptwenty"){
				// this.getTwenty()
				// this.getTwentySummary()
			}
			else if(tab.name == "fbidentity"){
				this.searchFbPrice = ""
				// this.getFbPrice()
			} else if(tab.name == "fbprice"){
				// this.getFbIdentity()
			}
			else if(tab.name == "fbsession"){
				// this.getFbIdentity()
				// this.getFbSession(1,this.selectedFilterSession)
				this.getFbSessionWarning()
			}
		},
		tabClickSession(tab){
			if(tab.name == "index"){
				this.getFbIdentity()
			} else if(tab.name == "upload"){
				
			}
		},
		readMore(text){
			if(text){
				if(text.length > 100) return text.substring(0, 100) + "..."
				else return text
			} else{
				return text
			}
		},
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async addFacebookPrice(){
			if(_.isEmpty(this.domain_name) || _.isEmpty(this.country_code) || _.isEmpty(this.country_name) || _.isEmpty(this.price_bi) || _.isEmpty(this.price_ui)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            if (this.price_model == '1') {
                this.model_name = ""
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-fb-price',
				method:'POST',
				data:{
					model_name:this.model_name,
					domain_name:this.domain_name,
					country_code:this.country_code,
					country_name:this.country_name,
                    price_bi: this.price_bi,
                    price_ui: this.price_ui
				}
			}).then(response => {
                this.dialogFormVisible = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.clear()
					this.paginateFbPrice()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisible = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
		},
		async addFacebookIdentity(){
			if(_.isEmpty(this.type_identity) || _.isEmpty(this.maskingName) || _.isEmpty(this.identityNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

			// let duplicate = this.find_duplicate_in_array(this.price_model_identity,'model')
			// console.log(duplicate);
			// if (duplicate.length > 0) {
			// 	this.$message.error({
            //         showClose: false,
            //         message: "Country Model can't duplicate"
            //     });
            //     return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-fb-identity',
				method:'POST',
				data:{
					type: this.type_identity,
					maskingName: this.maskingName,
					identityNumber: this.identityNumber,
					// price_model : this.price_model_identity
				}
			}).then(response => {
                this.dialogFormVisibleIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.clear()
					this.paginateFbIdentity()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
		},
		async editFacebookPrice(){
			// console.log(this.editFbPrice);
			if(!this.editFbPrice.id){
                this.$message.error({
                    showClose: false,
                    message: 'Id is undefined'
                });
                return
            }

            if (this.price_model_edit == '1') {
                this.editFbPrice.model_name = ""
            }
			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/update-fb-price',
				method:'POST',
				data:{
					id: this.editFbPrice.id,
					model_name:this.editFbPrice.model_name,
					domain_name:this.editFbPrice.domain_name,
					country_code:this.editFbPrice.country_code,
					country_name:this.editFbPrice.country_name,
                    price_bi: this.editFbPrice.price_bi,
                    price_ui: this.editFbPrice.price_ui
				}
			}).then(response => {
                this.dialogFormVisibleEdit = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.paginateFbPrice()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleEdit = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				this.paginateFbPrice()
				return error
			})
		},
		async editFacebookIdentity(){
			// console.log(this.editIdentity);
			if(!this.editIdentity.id){
                this.$message.error({
                    showClose: false,
                    message: 'Id is undefined'
                });
                return
            }

			// let duplicate = this.find_duplicate_in_array(this.editIdentity.price_model,'facebook_price')
			// console.log(duplicate);
			// if (duplicate.length > 0) {
			// 	this.$message.error({
            //         showClose: false,
            //         message: "Country Model can't duplicate"
            //     });
            //     return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/update-fb-identity',
				method:'POST',
				data:{
					id: this.editIdentity.id,
					type:this.editIdentity.type,
					identityNumber:this.editIdentity.identityNumber,
					maskingName:this.editIdentity.maskingName,
					// price_model:this.editIdentity.price_model
				}
			}).then(response => {
                this.dialogFormVisibleEditIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.paginateFbIdentity()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleEditIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				this.paginateFbIdentity()
				return error
			})
		},
		async paginateFbPrice(page) {
			this.currentPageRequest = page
			await this.getFbPrice(page)
		},
		async paginateFbIdentity(page) {
			this.currentPageIdentity = page
			await this.getFbIdentity(page)
		},
		async paginateFbSession(page) {
			this.currentPageSession = page
			await this.getFbSession(page,this.selectedFilterSession)
		},
		async paginateHSM(page){
			this.currentPage = page
			await this.getAllHSM(this.currentPage)
		},
		async getFbPrice(page = 1){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-price',
				method: 'GET',
				params: {
					page: page,
					search: this.searchFbPrice
				}
			}).then(({ data }) => {
				data.data.data.forEach(element => {
					element.price_bi = Number(element.price_bi)
					element.price_ui = Number(element.price_ui)
				});
				// console.log(data.data.data);
				this.reqFbPrice = data.data.data
                this.totalFbPrice = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getTwenty(page = 1){
			if (!this.selectedStartDateTwenty || !this.selectedStartDateTwenty[0] || !this.selectedStartDateTwenty[1] || !this.selectedMessageTypeFieldTwenty || !this.selectedFilterTwenty) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }
            this.loadingTemplate = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeFieldTwenty,
                    filter: this.selectedFilterTwenty,
                    "startDate":this.selectedStartDateTwenty[0],
                    "endDate":this.selectedStartDateTwenty[1],
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                // console.log('res', res);
                if(res.data.ec == 200){
					if (Array.isArray(res.data.data)) {
                        this.dataTwenty = res.data.data
                    }
                    else{
                        this.dataTwenty = res.data.data.data
                    }
                        // this.dataTwenty = res.data.data
                }

				this.loadingTemplate = false
            })
            .catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
				this.loadingTemplate = false
            })
            
        },
		async getTwentySummary(page = 1){
			if (!this.selectedStartDateTwenty || !this.selectedStartDateTwenty[0] || !this.selectedStartDateTwenty[1]) {
                this.$message.error({
                    showClose: false,
                    message: 'Field selected date is required'
                });
                return
            }
            this.loadingTemplate = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty-summary",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeFieldTwenty,
                    filter: this.selectedFilterTwenty,
                    "startDate":this.selectedStartDateTwenty[0],
                    "endDate":this.selectedStartDateTwenty[1],
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                // console.log('res summary', res.data.data);
                if(res.data.ec == 200){
					this.dataTwentySummary = [res.data.data]
                }

				this.loadingTemplate = false
            })
            .catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
				this.loadingTemplate = false
            })
            
        },
		async getActive(page = 1){
			if (!this.selectedMessageTypeField || !this.selectedFilter || !this.selectedField) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }
            this.loadingTemplate = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/active-business",
                method: 'get',
                params: {
                    page: page,
                    type: this.selectedMessageTypeField,
                    month: this.selectedFilter,
                    filter: this.selectedField,
                    search: ''
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                // console.log('res', res);
                if(res.data.ec == 200){
					if (Array.isArray(res.data.data)) {
                        this.dataActive = res.data.data
                        this.dataActiveTotal = res.data.total || 0
                    }
                    else{
                        this.dataActive = res.data.data.data
                        this.dataActiveTotal = res.data.data.total || 0
                    }
                }

				this.loadingTemplate = false
            })
            .catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
				this.loadingTemplate = false
            })
            
        },
		async getFbIdentity(page = 1, filter = null){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					page: page,
					all: filter ? true: null,
					filter: filter,
					search: this.searchFbIdentity
				}
			}).then(({ data }) => {
				var dataConsumen =
					data &&
					data.data &&
					data.data.consumen
						? data.data.consumen
						: [];
				// console.log(data.data.data);
				this.reqFbIdentity = dataConsumen
				if(filter){
					this.totalFbIdentity = this.reqFbIdentity.length
				}
				else{
					this.totalFbIdentity = data.data.total	
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getMetaData(){
            this.loadingTemplate = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-meta",
                method: 'get',
                params: {
                    // page: page,
                    type: 'monthly',
                    filter: moment().format("MM"),
                    year: moment().format("YYYY")
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                // console.log('res meta', res);
                if(res.data.ec == 200){

                    // if (Array.isArray(res.data.data)) {
                    //     this.tableData = res.data.data
                    // }
                    // else{
                    //     this.tableData = res.data.data.data
                    // }
                }
            	this.loadingTemplate = false
            })
            .catch(error => {
                this.loadingTemplate = false
				this.$swal(this.$t('error'), error.message, "error")
            })
		},
		async getFbSession(page = 1, filter = null){
			if (!this.selectedStartDateSession || !this.selectedStartDateSession[0] || !this.selectedStartDateSession[1]) {
				return
			}
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions',
				method: 'GET',
				params: {
					page: page,
					filter: filter,
					search: this.searchFbSession,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				// console.log(data.data.data);
				this.reqFbSession = data.data.data
				this.totalFbSession = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getPicGroup(filter = null) {

			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions-group',
				method: 'GET'
			}).then(({ data }) => {
				var dataPicBusiness =
					data &&
					data.data &&
					data.data.data
						? data.data.data
						: [];

				this.picBusinessGroup = dataPicBusiness
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSessionSummary(filter = null){
			if (!this.selectedStartDateSession || !this.selectedStartDateSession[0] || !this.selectedStartDateSession[1]) {
				return
			}

			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions-summary',
				method: 'GET',
				params: {
					search: this.searchFbSession,
					filter: filter,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				// console.log(data.data.data);
				this.reqFbSessionSummary = data.data.data
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSessionWarning(){
			// if (!this.selectedStartDateSession || !this.selectedStartDateSession[0] || !this.selectedStartDateSession[1]) {
			// 	return
			// }

			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions-warning',
				method: 'GET',
				params: {
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				// console.log(data.data);
				this.reqFbSessionWarn = data.data || null
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSessionDetail(page = 1){
			this.loadingDetailSession = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions/' + this.idDetailSession,
				method: 'GET',
				params: {
					phone_number: this.phoneNumberSessionSelected,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				// console.log(data.data.data);
				this.dataDetailSession = data.data.data
				this.loadingDetailSession = false
			}).catch(error => {
				this.loadingDetailSession = false
			})
		},
		async detailPrice(param){
			this.$router.push('business/' + param)
		},
		clear(){
			this.editFbPrice = {}
			this.editIdentity = {}
			this.price_model_identity = [{model:{modelName: "",countryName: "", domainName:""}}]
			this.price_bi = 0
            this.price_ui = 0
            this.country_code = ''
            this.country_name = ""
            this.domain_name = ''
            this.model_name =""
            this.price_model = "1",
			this.type_identity = "waba_id"
			this.maskingName = ""
			this.identityNumber = ""
		}
	},
	// async beforeMount(){
    //     let d = new Date(2022,2);
    //     d.setDate(d.getDate()-1);
        
	// 	for(let i = 12; i >= 0; i--){
	// 		// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
    //         let data = {
	// 			value: moment().subtract(i, 'month').format("YYYY-MM"),
	// 			label: moment().subtract(i, 'month').format("MMM YYYY")
	// 		}

    //         if (data.value <  moment(d).format("YYYY-MM")) {
    //             data.disabled = true
    //         }

	// 		this.monthly.push(data) 
	// 	}
	// },
	async mounted(){
        // await this.getMetaData()
		this.getActive()
		this.getTwenty()
		this.getTwentySummary()
        this.getFbIdentity()
		this.getFbSession(1,this.selectedFilterSession)
		this.getFbSessionSummary(this.selectedFilterSession)
		this.getFbSessionWarning()
		this.getFbPrice()
		this.getPicGroup()
	},
    created(){
        this.countries = countryCodes.all()
    }
}
</script>
<style>
.swal2-container {
	z-index: 10000 !important;
}
</style>
<style lang="scss">
@import '../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
